import { Launch as LaunchIcon } from '@mui/icons-material';
import { Typography } from '@mui/material';
import React from 'react';

interface ShippingIdentifierProps {
  index: number;
  shippingNumber: string | number;
  onLinkClick: () => void;
  isFirst: boolean;
}

const ShippingIdentifier: React.FC<ShippingIdentifierProps> = ({
  index,
  shippingNumber,
  onLinkClick,
}) => {
  return (
    <div className='flex items-center gap-4 min-w-[150px]'>
      <div className='w-8 h-8 rounded bg-[#ff750012] flex items-center justify-center text-[#ff7500] font-bold text-sm flex-shrink-0'>
        {index + 1}
      </div>

      <div
        onClick={onLinkClick}
        className='flex items-center gap-1 cursor-pointer px-2 py-1 rounded transition-all'
      >
        <LaunchIcon sx={{ fontSize: 20, color: '#2196f3' }} />
        <Typography
          variant='h6'
          sx={{
            color: '#2196f3',
            fontWeight: 600,
            lineHeight: 1,
            fontSize: '1.15rem',
            '&:hover': { textDecoration: 'underline' },
          }}
        >
          {shippingNumber}
        </Typography>
      </div>
    </div>
  );
};

export default ShippingIdentifier;
